export const CONVERSATION = "conversation";
export const DANGER = "danger";
export const OR = "or";
